module.exports = __webpack_public_path__ + "static/media/classFour.dd1df8f4.jpg";